module.exports = __webpack_public_path__ + "static/media/Fem_Low.63854033.svg";